<template>
  <div>
    <el-dialog title="制作签章" :visible.sync="viseble" width="550px" top="5vh">
      <el-form
        ref="madeForm"
        class="made-style"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
      >
        <el-form-item label="签章名称" prop="signName">
          <el-input
            v-model="form.signName"
            placeholder="请输入签章名称"
            maxlength="15"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="签章样式" prop="signType" v-if="false">
          <div class="sign-style">
            <!-- 圆形 -->
            <div
              key="img-1"
              :class="form.signType == 0 ? 'use-style' : ''"
              @click="changeUse(0)"
            >
              <img src="../../static/images/tpl/roundSign.gif" alt="" />
            </div>
            <!-- 椭圆 -->
            <!-- <div
              key="img-2"
              :class="form.signType == 1 ? 'use-style' : ''"
              @click="changeUse(1)"
            >
              <img src="../../static/images/tpl/ellipseSign.gif" alt="" />
            </div> -->
          </div>
        </el-form-item>
        <el-form-item label="印章颜色">
          <el-radio-group v-model="form.color" class="color-radio" @change="medeSign">
            <el-radio :label="1">
              <div class="color-item-sty" :class="{'select-sty':!!(form.color == 1)}">
                <div class="seal-dome red"></div>
              </div>
            </el-radio>
            <el-radio :label="2">
              <div class="color-item-sty" :class="{'select-sty': !!(form.color == 2)}">
                <div class="seal-dome blue"></div>
              </div>
            </el-radio>
            <el-radio :label="3">
              <div class="color-item-sty" :class="{'select-sty':!!(form.color == 3)}">
                <div class="seal-dome black"></div>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="环排字（企业名称）" prop="mainText">
          <el-input
            v-model="form.mainText"
            type="textarea"
            :rows="3"
            maxlength="25"
            show-word-limit
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="横排字（抬头文字）">
          <el-input
            v-model="form.titleText"
            placeholder="请输入抬头文字"
            maxlength="5"
            show-word-limit
            :disabled="form.mainText.length > 15"
          ></el-input>
        </el-form-item>
        <el-form-item label="印章编码（防伪码）">
          <el-input
            v-model="form.signCode"
            placeholder="请输入印章编码"
            maxlength="15"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="预览效果">
          <div v-if="previewUrl">
            <img width="160px" :src="fileOperShow(previewUrl)" alt="" />
          </div>
          <el-button @click="medeSign">预览效果</el-button>
        </el-form-item>
        <p class="tip-text">
          在线创建印章如不满足需求（企业名称过长），建议使用本地上传方式创建印章。
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viseble = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          @click="confirmSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fileOperShow,
  postTempFileOper
} from "../../assets/js/http-serve/http-methods";
import EntSignController from "../../assets/js/http-serve/entSignController";
export default {
  props: {
    onLineVise: { type: Boolean, default: false },
    signInfo: { type: Object, default: {} }
  },
  data () {
    return {
      viseble: false,
      fileOperShow,
      targetId: "",
      loading: false,
      formLabelWidth: "150px",
      form: {
        signName: "",
        signType: 0,
        mainText: "",
        titleText: "",
        signCode: "",
        color:1, // 1 红色 2 蓝色 3 黑色
      },
      rules: {
        signName: [
          { required: true, message: "请输入签章名称", trigger: "blur" }
        ],
        signType: [
          { required: true, message: "请选择签章样式", trigger: "blur" }
        ],
        mainText: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ]
      },
      previewUrl: ""
    }
  }, // data end
  methods: {
    async confirmSubmit () {
      this.loading = true;
      if (this.previewUrl) {
        this.reqConfirm();
      } else {
        // 没有执行预览，先执行预览
        this.medeSign().then(async res => {
          await this.reqConfirm(res);
        });
      }
    },
    async reqConfirm (data = this.previewUrl) {
      const param = Object.assign(
        {
          targetId: this.targetId,
          targetFix: ".png",
          productionType: 1 // 章制作类型(1为在线制作 其他为自主制作)
        },
        this.form
      );
      EntSignController.update(param)
        .then(res => {
          this.$emit("getChapterList");
          this.loading = false;
          this.viseble = false;
          // this.openOrClose();
          this.$message({ message: "签章保存成功", type: "success" });
        })
        .catch(err => {
          this.loading = false;
          this.$confirm(err.description || "签章保存失败", "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          });
        });
    },
    // 制作签章前需要先请求后端预览
    medeSign () {
      return new Promise((resolve, reject) => {
        this.$refs.madeForm.validate(valid => {
          if (valid) {
            postTempFileOper()
              .then(res => {
                let { data } = res;
                if (!res.success) {
                  this.$message(res.description);
                  reject();
                  return;
                }
                this.targetId = data.targetId;
                let param = Object.assign({}, data, this.form);
                EntSignController.previewSign(param)
                  .then(res => {
                    this.previewUrl = res.data;
                    resolve(res.data);
                  })
                  .catch(err => {
                    reject(err);
                  });
              })
              .catch(err => {
                this.$message(err || "网络错误请重试");
                reject(err);
              });
          } else {
            this.loading = false;
            reject();
          }
        });
      });
    },
    // 打开或关闭窗口
    openOrClose () {
      this.$emit("viseControl");
      // 清空状态
      this.form = {
        signName: "",
        signType: 0,
        mainText: "",
        titleText: "",
        signCode: ""
      };
      this.previewUrl = "";
    },
    // 使用签章样式
    changeUse (key) {
      this.form.signType = key;
    }
  }, // methods end
  watch: {
    onLineVise (val) {
      if (val) {
        this.viseble = true;
        console.log('this.signInfo',this.signInfo);
        if (Object.keys(this.signInfo).length > 0) {
          this.form = JSON.parse(JSON.stringify(this.signInfo));
          this.form.color = this.signInfo.color || 1;
        }
      } else {
        this.viseble = false;
        this.openOrClose();
      }
    }
  }
};
</script>

<style scoped lang="less">
@import url('../../assets/style/cssVariable.less'); //引入公共css类
.made-style {
  margin-top: 15px;
  .sign-style {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: space-evenly;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    > div {
      &:hover {
        box-shadow: 0 0 4px 0;
      }
      > img {
        width: 100px;
      }
    }
  }
  .use-style {
    border-radius: 4px;
    border: 1px solid red;
  }
}
.tip-text {
  font-size: 12px;
  color: #ec1c1c;
}
.seal-dome {
  // width: 58px;
  // height: 26px;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  cursor: pointer;
}
.blue {
background-color: rgb(0,0,245);
}
.red {
background-color: rgb(234,51,35);
}
.black{
background-color: rgb(0,0,0);
}
.color-radio{
  /deep/ .el-radio__input{
    display: none;
  }
  /deep/ .el-radio{
    margin-right: 5px;
  }
}
.color-item-sty{
  width: 58px;
  height: 26px;
  padding: 2px;
  border-radius: 2px;
  position: relative;
  border: 1px solid transparent;
}
.select-sty{
  border: 1px solid @ebq-red !important;
}
.select-sty::after{
  content: "";
  display: inline-block;
  width: 10px;
  height: 5px;
  position: absolute;
  border-left: 2px solid @ebq-white;
  border-bottom: 2px solid @ebq-white;
  transform: rotate(-45deg);
  top: 7px;
  left: 23px;
}
.flex-around{
display: flex;
align-items: center;
justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// components/tpl-editor/signOnline.vue